export interface AuthorInfo {
  name: string;
  bio?: string;
  imageUrl?: string;
  slug?: string;
}

export interface SchemaArticleProps {
  title: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  author?: string | AuthorInfo;
  url?: string;
  logo?: string;
  imgUrl?: string;
  id: string;
  isAccessibleForFree?: boolean;
  keywords?: string[];
  articleSection?: string;
  type?: 'Article' | 'NewsArticle';
}

export function isAuthorInfo(author: string | AuthorInfo | undefined): author is AuthorInfo {
  return typeof author === 'object' && author !== null && 'name' in author;
}

export interface NormalizedAuthor extends AuthorInfo {
  isOrganization: boolean;
}

export function extractAuthorData(author?: string | AuthorInfo): NormalizedAuthor {
  const defaultAuthor = 'NAF';

  if (!author) {
    return {
      name: defaultAuthor,
      isOrganization: true,
    };
  }

  if (isAuthorInfo(author)) {
    return {
      name: author.name || defaultAuthor,
      bio: author.bio,
      imageUrl: author.imageUrl,
      slug: author.slug,
      isOrganization: author.name === defaultAuthor,
    };
  }

  return {
    name: author,
    isOrganization: author === defaultAuthor,
  };
}
